// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"95":"190a6c20","857":"5ba2ddf6"}[chunkId] + ".js";
};